export default __webpack_public_path__ + "static/media/DNo.25-1.b92f9e7f.jpg";